import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, OnInit, Signal, signal } from '@angular/core'
import { APP_CONFIG } from '@ui-core/constants/app.constant'
import { ButtonModule } from 'primeng/button'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'

@Component({
    selector: 'app-unsaved-changes-message',
    imports: [ButtonModule, CommonModule],
    templateUrl: './unsaved-changes-message.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnsavedChangesMessage implements OnInit {
    message = signal<string>(APP_CONFIG.leavingMessage.messageFull)
    cancelLabel = signal<string>('No, cancel')
    actionLabel = signal<string>('Yes, discard changes')

    private readonly dialogConfig = inject(DynamicDialogConfig)
    private readonly dialogRef = inject(DynamicDialogRef)

    ngOnInit(): void {
        this.message.set(this.checkPropertyAndGetValue('message')())
        this.cancelLabel.set(this.checkPropertyAndGetValue('cancelLabel')())
        this.actionLabel.set(this.checkPropertyAndGetValue('actionLabel')())
    }

    checkPropertyAndGetValue(property: string): Signal<string> {
        return this.dialogConfig.data[property] && this.dialogConfig.data[property] !== ''
            ? signal(this.dialogConfig.data[property])
            : (this[property as keyof this] as Signal<string>)
    }

    close(): void {
        this.dialogRef.close(false)
    }

    discard(): void {
        this.dialogRef.close(true)
    }
}
